// extracted by mini-css-extract-plugin
module.exports = {"button":"_e31a86c","stakeError":"_afd0ac1"};